import { render, staticRenderFns } from "./DiagnosticsFilter.vue?vue&type=template&id=8908ff50&scoped=true&"
import script from "./DiagnosticsFilter.vue?vue&type=script&lang=js&"
export * from "./DiagnosticsFilter.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticsFilter.vue?vue&type=style&index=0&id=8908ff50&lang=sass&scoped=true&"
import style1 from "./DiagnosticsFilter.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8908ff50",
  null
  
)

export default component.exports